import {
  ErrorOvalIcon,
  InfoOvalIcon,
  SuccessOvalIcon,
  semanticAlertRedIcon,
  semanticInfoBlueIcon,
  semanticSuccessGreenIcon,
} from "@songtradr/component-library";
import { Body } from "@songtradr/design-language";
import { AlertContainer, Props, text } from "./AlertMessage.Parts";

/** @deprecated - use Alert instead where possible */
export const AlertMessage = ({
  isFormValid,
  errorMessage,
  successMessage,
  infoMessage,
  topMargin,
}: Props) => {
  if (errorMessage) {
    return (
      <AlertContainer
        icon={<ErrorOvalIcon aria-hidden="true" color={semanticAlertRedIcon} />}
        variant="error"
        title=""
        $topMargin={topMargin}
        className="alert-message-error"
      >
        <Body variant="small">{errorMessage}</Body>
      </AlertContainer>
    );
  } else if (isFormValid)
    return (
      <AlertContainer
        icon={
          <SuccessOvalIcon
            aria-hidden="true"
            color={semanticSuccessGreenIcon}
          />
        }
        variant="success"
        title=""
        $topMargin={topMargin}
        className="alert-message-success"
      >
        <Body variant="small">
          {successMessage ?? text.defaultSuccessMessage}
        </Body>
      </AlertContainer>
    );
  else if (infoMessage) {
    return (
      <AlertContainer
        icon={<InfoOvalIcon aria-hidden="true" color={semanticInfoBlueIcon} />}
        variant="information"
        title=""
        $topMargin={topMargin}
        className="alert-message-info"
      >
        <Body variant="small" color={semanticInfoBlueIcon}>
          {infoMessage}
        </Body>
      </AlertContainer>
    );
  }
  return null;
};
